export default "__VITE_PUBLIC_ASSET__9bea411d__"